import React from "react"


// context for all ingredients in cabinet
const CabinetContext = React.createContext({
  items: [],
  addItem: (item) => {},
  removeItem: (id) => {},
  clearCabinet: () => {},
  saveCabinet: () => {},
});

export default CabinetContext;
